const errorMessageEN = {
    'error.unsupported-asset': 'Unsupported Asset Type',
    'PERMISSION_DENIED': 'Permission denied',
    'Forbidden resource': 'Forbidden resource',
    'FUNDER_ERR_NULL': 'Required Field(s) are missing',
    'FUNDER_ERR_EMPTY': 'Required Field(s) are missing',
    'FUNDER_ERR_LENGTH': 'Invalid format - Length',
    'FUNDER_ERR_MAX_VALUE': 'Invalid Range',
    'FUNDER_ERR_MIN_VALUE': 'Invalid Range',
    'FUNDER_ERR_FORMAT_DIGIT': "Invalid format",
    'FUNDER_ERR_FORMAT_EMAIL': 'Invalid email format',
    'FUNDER_ERR_FORMAT_PHONE_NO': "Invalid phone number format",
    'FUNDER_ERR_FORMAT_ALPHANUMERIC': 'Invalid format - Alphanumeric',
    'FUNDER_ERR_FORMAT_POST_CODE': 'Invalid post code',
    'FUNDER_ERR_NOT_FOUND': 'Funder record not found',
    'FUNDER_ERR_PERMISSION_DENIAL': 'Forbidden resource',
    'FUNDER_ERR_UNAVAILABLE_ASSET': 'Unavailable asset',
    'FUNDER_ERR_SUB_ASSET_SOLD': 'Sub-asset sold',
    'FUNDER_ERR_INSUFFICIENT_BALANCE': 'Insufficient balance',
    'FUNDER_ERR_INVALID_PARAM': 'Invalid input',
    'PHONE_NO_ERR_INVALID': 'Invalid phone code',
    'COGNITO_ERR_NOT_FOUND': 'User account not found',
    'UNEXPECTED_ERROR': 'Unexpected Error',
};

const errorMessage_ZH_TW = Object.freeze({
    'error.unsupported-asset': '不支援資產種類',
    'PERMISSION_DENIED': '沒有權限',
    'Forbidden resource': '沒有權限',
    'FUNDER_ERR_NULL': '請輸入必填項目',
    'FUNDER_ERR_EMPTY': '請輸入必填項目',
    'FUNDER_ERR_LENGTH': '錯誤格式 - 長度',
    'FUNDER_ERR_MAX_VALUE': '錯誤數據範圍',
    'FUNDER_ERR_MIN_VALUE': '錯誤數據範圍',
    'FUNDER_ERR_FORMAT_DIGIT': "格式錯誤",
    'FUNDER_ERR_FORMAT_EMAIL': '電郵格式錯誤',
    'FUNDER_ERR_FORMAT_PHONE_NO': "電話格式錯誤",
    'FUNDER_ERR_FORMAT_ALPHANUMERIC': '格式錯誤 - 字母數字',
    'FUNDER_ERR_FORMAT_POST_CODE': '郵政編號錯誤',
    'FUNDER_ERR_NOT_FOUND': '投資者資料不存在',
    'FUNDER_ERR_PERMISSION_DENIAL': '沒有權限',
    'FUNDER_ERR_UNAVAILABLE_ASSET': '未能提供資產',
    'FUNDER_ERR_SUB_ASSET_SOLD': '資產已售出',
    'FUNDER_ERR_INSUFFICIENT_BALANCE': '餘額不足',
    'FUNDER_ERR_INVALID_PARAM': '所提供資料錯誤',
    'PHONE_NO_ERR_INVALID': '電話區號錯誤',
    'COGNITO_ERR_NOT_FOUND': '用戶不存在',
    'UNEXPECTED_ERROR': '不可預期錯誤',
});


export {
    errorMessageEN,
    errorMessage_ZH_TW
}